<template>
  <!-- sidebar start -->
  <div class="ba-navbar sc5" :class="$store.state.sidebarMinimize ? null : 'ba-navbar-show'">
    <div class="ba-navbar-user text-center">
      <div @click="$store.state.sidebarMinimize = true" class="menu-close">
        <i class="la la-times"></i>
      </div>
      <div class="thumb">
        <!-- <img src="assets/img/user.png" alt="user"> -->
        <!-- <img :src="user.avatarb64" :alt="user.name" height="80px"> -->
        <i class="fa fa-user-circle text-primary fa-5x"></i>
      </div>
      <div class="details">
        <h5>{{ user.firstname + ' ' + user.lastname }} - {{ user.company }}</h5>
        <!-- <p>ID: {{ user.id }}</p> -->
      </div>
    </div>
    <div class="ba-balance-inner mb-3 text-end align-self-center">
      <div class="icon">
        <i class="las la-pound-sign la-4x"></i>
      </div>
      <h5 class="title">Order Balance</h5>
      <!-- <h5 class="amount">GBP {{ $store.state.balance }}</h5> -->
      <h5 :class="parseFloat($store.state.balance) >= 0 ? 'credit' : 'debit'">GBP {{ $store.state.balance }}</h5>
    </div>
    <!-- <div class="ba-add-balance-title">
      <h5>Deposit</h5>
      <a href="#"><i class="fa fa-plus"></i></a>
    </div> -->
    <!-- dark area Start -->
    <div class="dark-area">
      <div class="section-title mb-0">
        <p class="subtitle">Theme Mode</p>
        <h3 class="title mb-0">{{ theme }} Mode</h3>
        <div class="change-mode">
          <div class="custom-control custom-switch custom-switch-icon custom-control-inline">
            <div class="custom-switch-inner">
              <p class="mb-0"> </p>
              <input type="checkbox" class="custom-control-input" id="dark-mode" data-active="true">
              <label class="custom-control-label" for="dark-mode" data-mode="toggle">
                <span @click="theme = 'light'" class="switch-icon-left"><i class="fa fa-sun-o"></i></span>
                <span @click="theme = 'dark'" class="switch-icon-right"><i class="fa fa-moon-o"></i></span>
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- dark area End -->
    <div class="ba-main-menu">
      <h5>Menu</h5>
      <ul>
        <li><a class="ui-side-menu ui-side-menu-active" @click="$router.push('/')">Home</a></li>
        <!-- <li><a class="ui-side-menu" href="all-page.html">Pages</a></li>
        <li><a class="ui-side-menu" @click="$router.push('/about')">About Us</a></li>
        <li><a class="ui-side-menu" href="cart.html">My Cart</a></li>
        <li><a class="ui-side-menu" @click="$router.push('/settings')">Setting</a></li>
        <li><a class="ui-side-menu" @click="$router.push('/notifications')">Notification</a></li>
        <li><a class="ui-side-menu" href="component.html">Component</a></li> -->
        <li><a class="ui-side-menu mt-4" @click="$router.push('/logout')">Sign Out</a></li>
      </ul>
    </div>
  </div>
  <!-- sidebar end -->

</template>

<script>
import { mapGetters } from "vuex";
import gql from "graphql-tag";

export default {
  name: "TheSidebar",
  data() {
    return {
      busy: false,
      sidebar: true,
      compress: false,
      theme: ""
    };
  },
  mounted() {
    this.theme = this.user.theme
  },
  computed: {
    show() {
      return this.$store.state.sidebarShow;
    },
    minimize() {
      return this.$store.state.sidebarMinimize;
    },
  },
  watch: {
    theme: {
      // async handler(newVal, oldVal) {
      //   await this.user_save();
      // }
    }
  },
  methods: {
    async user_save() {
      this.busy = true;

      let variables = {
        rows: [
          {
            id: this.user.id,
            theme: this.theme
          }
        ]
      }
      console.log("user_save", variables);

      try {
        const response = await this.$apollo.mutate({
          mutation: gql`
              mutation setup_users_save(
                  $rows: [setup_users_input]
              ) {
                  setup_users_save(rows: $rows) {
                      id
                      theme                                
                  }
              }
          `,
          variables,
        });
        this.message = "<span class='text-primary'>Saved it.</span>";
      } catch (error) {
        this.message = "<span class='text-danger'>" + error.message + "</span>";
      }
      await this.$store.dispatch('currentUser')
      this.busy = false;
    }
  }
};
</script>
